import { fetchJSON } from "lib/fetch";
import siteConfig from "site-config";

export interface ISpacesService {
    createSpace: (payload: nuorder.folder.v1.CreateSpaceRequest) => Promise<nuorder.folder.v1.Space>;
    fetchMySpaces: (merchantId: string) => Promise<nuorder.folder.v1.ListSpacesResponse>;
    fetchMerchantSpaces: (merchantId: string) => Promise<nuorder.folder.v1.ListSpacesResponse>;
}

export const spaces: ISpacesService = {
    createSpace: (payload: nuorder.folder.v1.CreateSpaceRequest) =>
        fetchJSON(`${siteConfig.goAPI}/v1/spaces`, {
            method: "POST",
            body: JSON.stringify(payload),
        }),
    fetchMySpaces: (merchantId: string) => fetchJSON(`${siteConfig.goAPI}/v1/merchants/${merchantId}/me/spaces`),
    fetchMerchantSpaces: (merchantId: string) => fetchJSON(`${siteConfig.goAPI}/v1/merchants/${merchantId}/spaces`),
};
